export default __webpack_public_path__ + "a81f4a2c09aeb885c320dbfd97d382b0.png";